import { render, staticRenderFns } from "./BoardMain.vue?vue&type=template&id=3a2788d8&scoped=true&"
import script from "./BoardMain.vue?vue&type=script&lang=js&"
export * from "./BoardMain.vue?vue&type=script&lang=js&"
import style0 from "./BoardMain.vue?vue&type=style&index=0&id=3a2788d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2788d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFlex,VRow})
